package com.example.mystybag.sharedmodels.project.requestModels

import com.example.mystybag.sharedmodels.AllCommands.CHECK_USER_EXISTS
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class CheckUserExistsRequestModel(
    val email: String = "",
    /** Optional profile data forwarded from social sign-in (e.g. Google). */
    val firstName: String? = null,
    val lastName: String? = null,
    val photoUrl: String? = null,
): BaseRequestModel(api = CHECK_USER_EXISTS)
